import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { v4 as uuidv4 } from 'uuid';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { getCspNonce, getUseSignifyd } from '@/redux/modules/config';
import { getSignifydSessionId, saveSignifydSessionId } from '@/redux/modules/signifyd';

export const Signifyd = () => {
    const dispatch = useAppDispatch();

    const cspNonce = useAppSelector(getCspNonce);
    const signifydSessionId = useAppSelector(getSignifydSessionId);
    const useSignifyd = useAppSelector(getUseSignifyd);
    const userIsLoggedIn = useAppSelector(isUserLoggedIn);

    useEffect(() => {
        if (useSignifyd && userIsLoggedIn) {
            const newSessionId = uuidv4();
            dispatch(saveSignifydSessionId(newSessionId));
        }
    }, [dispatch, useSignifyd, userIsLoggedIn]);

    if (!signifydSessionId) {
        return null;
    }

    return (
        <Helmet>
            {/* Signifyd copies data-csp-nonce onto the inline scripts it injects. No `nonce` attribute: the script's
                host is allow-listed, and browsers blank `nonce` after insertion, which makes Helmet re-insert the tag
                and re-run Signifyd's loader on every head update. */}
            <script
                data-order-session-id={signifydSessionId}
                defer
                id="sig-api"
                src="https://cdn-scripts.signifyd.com/api/script-tag.js"
                type="text/javascript"
                {...(cspNonce && { 'data-csp-nonce': cspNonce })}
            />
        </Helmet>
    );
};
